export const featureFlags = {
  enabledNavbarNetworkEnvSwitch: false,
};
